const language_EN = {

    es: 'Spanish',
    en: 'English',
    choose_language: 'Choose language',

    sing_to_continue: 'Sign in to continue',
    email: 'Email',
    password: 'Password',
    remember_me: 'Remember me',
    forgot_password: 'Forgot password?',
    sign_in: 'Sign in',

    search: 'Search',
    property_search: 'Property search',
    property_search_placeholder: 'Search for a property here',
    recently_searched : 'Recently searched',

    //policies
    cancellations_search_placeholder: 'Search Cancellations',
    fees_search_placeholder: 'Search Fees',
    other_policies_search_placeholder: 'Search Other Policies',
  




    // GuestRooms
    guestroom_list_column1: 'Room ID',
    guestroom_list_column2: 'Room Type Name',
    guestroom_list_column3: 'Room Type or Class',
    guestroom_list_column4: 'Maximum Occupancy',
    guestroom_list_column5: 'Minimum Occupancy',
    guestroom_list_column6: 'Maximum Adults',
    guestroom_list_column7: 'Maximum Children',
    
    // affiliation_award
    affiliation_award_column1: 'Award Name',
    affiliation_award_column2: 'Provider',
    affiliation_award_column3: 'Date Awarded',
    affiliation_award_column4: 'Official Appointment',
    affiliation_award_column5: 'Rating',
    affiliation_award_column6: 'Rating Symbol',
    
    // Amenities & Services
    Amenities_name : 'Name',
    Amenities_type :"Type",
    Amenities_included : 'Included in Room Rate',
    Amenities_proximity : 'Proximity',
    Amenities_typeDetail : 'Type Detail',

    //Other Distribution System
    Distribution_sys: 'System Name',
    Distribution_chain:'Chain',
    Distribution_hotel:'Hotel Code',
    Distribution_propertyS:'Property Name (Short)',
    Distribution_propertyL:'Property Name (Long)',


    // ReferencePoint
    Reference_name: 'Name',
    Reference_type: 'Type',
    Reference_code: '3 Character Airport Code',
    Reference_category: 'Category',
    Reference_direction: 'Direction/Description',
    Reference_search: 'Search Reference Points',
    

    //GuestRooms/roomtype
    guestroom_list_tab:'Guest Rooms Table',
    guest_room_tab1:'Room Type',
    guest_room_tab2:'Images',
    guest_room_tab3:'Amenities',
    guest_room_tab4:'Room Details',
    guest_room_tab5:'Features',
    guestrooms_property_search_placeholder:'Search Guest Rooms',
    guestrooms_property_search: 'Search Guest Rooms',
   

 
     // attraction
     attraction_column1: 'Name',
     attraction_column2: 'Type',
     attraction_column3: 'Attraction ID',
     attraction_column4: 'Type Standard',
     attraction_column5: 'Type Detail',
     attractions_tab1:'Detail',
     attractions_tab2:'Location',
     attraction_search:'Search Attractions',
    //EnvironmentalImpact
    environmental_impact_tab1:'General',
    environmental_impact_tab2:'Carbon Footprint',
    environmental_impact_tab3:'Energy Usage',
    environmental_impact_tab4:'Recycling Program',
    environmental_impact_tab5:'Water Usage',

    environmental_impact_general_tab1:'General',
    environmental_impact_general_tab2:'Certifications',
    environmental_impact_general_tab3:'Environmental Programs',

    //Basic Info Contacts
    basic_info_contacts_tab1:'Details',
    basic_info_contacts_tab2:'Address',
    basic_info_contacts_tab3:'Phone & Email',


    // Policies Pets
    policies_pets_search: 'Search Pet Policies'
}

export {
    language_EN
}
